const theme = {
  palette: {
    primary: "#1F3A7C",
    secondary: "#43AFCA",
  },
  typo: {
    fontFamily: "'Muli', sans-serif",
  },
};

export default theme;
